import { createContext, h } from 'preact'
import { useContext } from 'preact/hooks'

const CustomContext = createContext<any>(null)

export function Provider(props: any) {
  return (
    <CustomContext.Provider value={{ ...this.props.value }}>
      {props.children}
    </CustomContext.Provider>
  )
}

export function useCustomContext() {
  return useContext(CustomContext)
}
